export default "/assets/images/overreactor-small.98fdd3d32276fb31.png";